var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9821 15C7.79785 15 4.64937 15 1.46512 15C1.03578 15 1 14.9624 1 14.5108C1 10.1828 1 5.85484 1 1.48925C1 1.03763 1.03578 1 1.46512 1C7.79785 1 14.1306 1 20.4991 1C20.9642 1 21 1.03763 21 1.48925C21 5.8172 21 10.1452 21 14.5108C21 14.9624 20.9642 15 20.5349 15C17.3506 15 14.1664 15 10.9821 15ZM20.4991 1.79032C20.3918 1.86559 20.3202 1.94086 20.2487 1.97849C17.2791 4.5 14.3095 6.98387 11.3757 9.50538C11.0179 9.80645 11.0179 9.80645 10.6243 9.50538C7.65474 7.02151 4.72093 4.5 1.75134 2.01613C1.67979 1.94086 1.60823 1.86559 1.50089 1.79032C1.50089 6.04301 1.50089 10.2581 1.50089 14.4731C7.83363 14.4731 14.1664 14.4731 20.4991 14.4731C20.4991 10.2581 20.4991 6.04301 20.4991 1.79032ZM20.034 1.52688C13.9875 1.52688 8.01252 1.52688 1.96601 1.52688C5.00716 4.08602 7.97674 6.60753 10.9821 9.16667C13.9875 6.60753 16.9928 4.08602 20.034 1.52688Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.83784eedfead17d9f97dea882e2361b3.svg";
export { ForwardRef as ReactComponent };